import React from 'react';

const SvgInfo = props => (
  <svg width={17} height={17} {...props}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Request-information---Edit---No-locations" transform="translate(-1093.000000, -158.000000)" fill="#046FE2" fillRule="nonzero">
        <g id="request-info---tabs" transform="translate(1078.000000, 146.000000)">
          <g id="Active-tab">
            <g id="tabs">
              <path d="M23.5,29 C18.8055796,29 15,25.1944204 15,20.5 C15,15.8055796 18.8055796,12 23.5,12 C28.1944204,12 32,15.8055796 32,20.5 C32,25.1944204 28.1944204,29 23.5,29 Z M23.5,28 C27.6421356,28 31,24.6421356 31,20.5 C31,16.3578644 27.6421356,13 23.5,13 C19.3578644,13 16,16.3578644 16,20.5 C16,24.6421356 19.3578644,28 23.5,28 Z M24,24 L24.8,24 C24.9104569,24 25,24.0895431 25,24.2 L25,24.8 C25,24.9104569 24.9104569,25 24.8,25 L22.2,25 C22.0895431,25 22,24.9104569 22,24.8 L22,24.2 C22,24.0895431 22.0895431,24 22.2,24 L23,24 L23,20 L22.2,20 C22.0895431,20 22,19.9104569 22,19.8 L22,19.2 C22,19.0895431 22.0895431,19 22.2,19 L23.4,19 L24,19 L24,24 Z M23.3,16 C23.8522847,16 24.3,16.4477153 24.3,17 C24.3,17.5522847 23.8522847,18 23.3,18 C22.7477153,18 22.3,17.5522847 22.3,17 C22.3,16.4477153 22.7477153,16 23.3,16 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgInfo;
